import { FC, HTMLAttributes, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/shared/button/Button';

interface QuickLinkProps extends HTMLAttributes<HTMLDivElement> {
  url: string;
  label: string;
  icon: JSX.Element;
}

export const QuickLink: FC<QuickLinkProps> = ({ url, label, icon }) => {
  const navigate = useNavigate();

  return (
    <Button onClick={() => navigate(url)} className="flex items-center gap-5 px-5">
      {icon}
      <p>{label}</p>
    </Button>
  );
};
